<template>
    <div class="steps">
        <step-header v-if="!loading" :step="currentStep" :title="getStepTitle()" />
        <loader v-if="loading && !saving">POBIERAM DANE</loader>
        <loader v-if="loading && saving">Zapisuję profil</loader>
        <step-personal-data v-if="currentStep === 1 && !loading" v-on:submit-data="personalDataSubmit" :form="personalData" />
        <step-social-services :socialServicesChecked="socialServicesChecked" :user="user" :submittedData="socialServicesData" v-if="currentStep === 2 && !loading" v-on:submit-data="socialServicesDataSubmit" v-on:go-back="goBack" :socialServices="apiData.socialServices" />
        <step-categories :submittedData="categoriesData" :categories="this.apiData.categories" v-if="currentStep === 3 && !loading" v-on:submit-data="categoriesSubmitData" v-on:go-back="goBack" />
        <step-delivery-data v-on:submit-data="deliverySubmitData" :form="deliveryData" v-if="currentStep === 4 && !loading" v-on:go-back="goBack" />
    </div>
</template>

<script>
    import StepHeader from '@/components/Steps/StepHeader.vue';
    import StepPersonalData from '@/components/Steps/StepPersonalData.vue';
    import StepSocialServices from "./StepSocialServices";
    import Loader from "../Loader";

    import Router from "../../routing.js";
    import StepCategories from "./StepCategories";
    import StepDeliveryData from "./StepDeliveryData";

    import { shortRegistrationMode } from '../../variables';

    export default {
        name: "steps",
        components: {
            StepDeliveryData,
            StepCategories,
            Loader,
            StepSocialServices,
            StepHeader, StepPersonalData
        },
        props: ['user'],
        mounted: function () {
            // GET /someUrl
            this.$http.get(Router.generate('app_get_form_data')).then(response => {
                this.loading = false;
                this.apiData.socialServices = response.body.socialServices;
                this.apiData.categories = response.body.categories;
            }, response => {
                location.reload();
            });
        },
        data: function () {
            return {
                currentStep: 1,
                loading: true,
                saving: false,
                apiData: {
                    socialServices: [],
                    categories: []
                },
                personalData: {
                    nick: '',
                    gender: -1,
                    firstName: '',
                    lastName: '',
                    email: '',
                    phone: {
                        prefix: '+48',
                        number: ''
                    },
                    city: '',
                    country: '',
                    birthDate: {
                        day: '',
                        month: '',
                        year: ''
                    },
                    terms: {
                        first: false,
                        second: false,
                        third: false
                    }
                },
                socialServicesData: false,
                socialServicesChecked: [],
                categoriesData: [],
                deliveryData: {
                    street: '',
                    houseNumber: '',
                    apartmentNumber: '',
                    city: '',
                    country: '',
                    postal: {
                        prefix: '',
                        suffix: ''
                    }
                }
            }
        },
        methods: {
            getStepTitle: function () {
                switch(this.currentStep) {
                    case 1:
                        return 'Twoje dane';
                    case 2:
                        return 'Twoje profile';
                    case 3:
                        return 'Zainteresowania';
                    case 4:
                        return 'Dane do wysyłek';
                }
            },
            personalDataSubmit: function (data) {
                this.personalData = data;
                this.currentStep = 2;
            },
            socialServicesDataSubmit: function (data) {
                this.socialServicesData = data.formData;
                this.socialServicesChecked = data.checkedBoxes;


                if(shortRegistrationMode) {
                    this.saving = true;
                    this.loading = true;
                    this.saveData();
                }
                else {
                    this.currentStep = 3;
                }
            },
            categoriesSubmitData: function (data) {
                this.categoriesData = data;
                this.currentStep = 4;
            },
            deliverySubmitData: function(data) {
                this.deliverySubmitData = data;
                this.saving = true;
                this.loading = true;
                this.saveData();
            },
            saveData: function() {

                let socialServicesData = [];

                for(let i = 0; i < this.socialServicesChecked.length; i++) {
                    socialServicesData.push(this.socialServicesData[this.socialServicesChecked[i]]);
                }

                let postData = {
                    personalData: this.personalData,
                    socialServicesData: socialServicesData,
                    categoriesData: this.categoriesData,
                    deliveryData: this.deliveryData
                };

                this.$http.post(Router.generate('update_user'), postData, Router.getAuthHeader())
                    .then(response => {
                        this.$router.push('thank-you');
                    }, response => {
                        this.loading = false;
                        Router.handleWrongRequest(response);
                    });
            },
            goBack: function () {
                if(this.currentStep > 1) {
                    this.currentStep -= 1;
                }
            }
        }
    }
</script>